export const navTab = [
  {
    id: 11,
    link: "/",
    name: "Home",
  },
  {
    id: 1,
    link: "/GreetingsSubCat",
    name: "Free Greetings",
  },
  {
    id: 2,
    link: "/InvitationSubCat",
    name: "Free Invitations",
  },
  // {
  //   id: 3,
  //   link: "/events",
  //   name: "Plan an Events (party)",
  // },
  // {
  //   id: 4,
  //   link: "/ComingSoon",
  //   name: "Banquet Halls",
  // },
  {
    id: 5,
    link: "/plantEcommerce",
    name: "Plants",
  },
  {
    id: 6,
    link: "/potsAll",
    name: "Pots",
  },
  // {
  //   id: 7,
  //   link: "/corporateGifting",
  //   name: "Corporate Gifting",
  // },
  {
    id: 8,
    link: "/homeDecorAll",
    name: "Home Decor",
  },
  // {
  //   id: 9,
  //   link: "/cakesandchochlate",
  //   name: "Cakes/Chocolates",
  // },
  {
    id: 10,
    link: "/inspirationCategory",
    name: "Wishfy Inspiration Board",
  },
  // {
  //   id: 11,
  //   link: "/ComingSoon",
  //   name: "AI Powered Gift",
  // },
  {
    id: 12,
    link: "/blogs",
    name: "Blogs",
  },
  {
    id: 13,
    link: "/aboutus",
    name: "About Us",
  },
];
